import React from 'react';

export function CloseIcon(): JSX.Element {
  return (
    <svg height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
      <title>Close dialog</title>
      <path
        clipRule='evenodd'
        d='M16.2421 7.75791C16.5768 8.09264 16.5768 8.63536 16.2421 8.97009L8.97009 16.2421C8.63536 16.5768 8.09264 16.5768 7.75791 16.2421C7.42317 15.9074 7.42317 15.3646 7.75791 15.0299L15.0299 7.75791C15.3646 7.42317 15.9074 7.42317 16.2421 7.75791Z'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M7.75791 7.75791C8.09264 7.42317 8.63536 7.42317 8.97009 7.75791L16.2421 15.0299C16.5768 15.3646 16.5768 15.9074 16.2421 16.2421C15.9074 16.5768 15.3646 16.5768 15.0299 16.2421L7.75791 8.97009C7.42317 8.63536 7.42317 8.09264 7.75791 7.75791Z'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472ZM12 1.71429C9.27206 1.71429 6.65585 2.79796 4.7269 4.7269C2.79796 6.65585 1.71429 9.27206 1.71429 12C1.71429 14.7279 2.79796 17.3442 4.7269 19.2731C6.65585 21.202 9.27206 22.2857 12 22.2857C14.7279 22.2857 17.3442 21.202 19.2731 19.2731C21.202 17.3442 22.2857 14.7279 22.2857 12C22.2857 9.27206 21.202 6.65585 19.2731 4.7269C17.3442 2.79796 14.7279 1.71429 12 1.71429Z'
        fillRule='evenodd'
      />
    </svg>
  );
}
